// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:950px){
    .bar-chart-widget-container{
        position: relative;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
    }
    .bar-chart-widget-header{
        width: 100%;
        padding: 16px 20px;
        padding-bottom: 0px;
        box-sizing: border-box;
    }
    .bar-chart-widget-header .details-header{
        display: flex;
        justify-content: space-between;
    }
    .bar-chart-widget-header .details-header p{
        margin: 0px;
    }
    .bar-chart-widget-header .details-header .control-buttons-container{
        display: flex;
        align-items: center;
    }
    .bar-chart-widget-header .details-header .export-button,
    .bar-chart-widget-header .details-header .maximize-button,
    .bar-chart-widget-header .details-header .minimize-button{
        position: relative;
        margin: 0px;
        border: none;
        background-color: transparent;
        cursor: pointer;
    }
    .bar-chart-widget-header .details-header .export-button img{
        height: 17px;
    }
    .bar-chart-widget-header .details-header .maximize-button img{
        height: 25px;
    }
    .bar-chart-widget-header .details-header .minimize-button img{
        height: 18px;
    }
    .bar-chart-widget-header .details-header .export-button .export-selections-container{
        position: absolute;
        z-index: 2;
        right: 8px;
        padding: 0px;
        border-radius: 2px;
        background-color: white;
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
    }
    .bar-chart-widget-header .details-header .export-button .export-selections-container button{
        width: 100%;
        text-align: left;
        padding: 5px 12px;
        display: block;
        white-space: nowrap;
        border: none;
        cursor: pointer;
        background-color: transparent;
    }
    .bar-chart-widget-header .details-header .export-button .export-selections-container button:hover{
        background-color: lightgray;
    }
    .bar-chart-widget-container .time-window-selector-container{
        position: relative;
    }
    .bar-chart-widget-container .show-time-window-selector-button{
        position: relative;
        padding: 0px;
        padding-top: 8px;
        padding-bottom: 4px;
        display: flex;
        align-items: center;
        cursor: pointer;
        border: none;
        color: rgb(136, 136, 136);
        background-color: transparent;
    }
    .bar-chart-widget-container .show-time-window-selector-button img{
        height: 16px;
        margin-right: 6px;
    }
    .bar-chart-widget-body{
        width: 100%;
        flex-grow: 1;
        padding: 10px 20px;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
    }
    .bar-chart-widget-body .legends-container{
        max-height: 15%;
        overflow-y: auto;
    }
    .bar-chart-widget-body .legends-container::-webkit-scrollbar{
        width: 5px;
    }
    .bar-chart-widget-body .legends-container::-webkit-scrollbar-thumb{
        border-radius: 2px;
        background-color: gray;
    }
    .bar-chart-widget-body .legends-container .legend-container{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .bar-chart-widget-body .legends-container .legend-container .key-container{
        display: flex;
        align-items: center;
    }
    .bar-chart-widget-body .legends-container .legend-container p{
        margin: 0px;
        margin-right: 4px;
        font-size: 13px;
        color: rgb(58, 58, 58);
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .bar-chart-widget-body .legends-container .legend-container .value-container p{
        font-weight: 500;
    }
    .bar-chart-widget-body .graph-container{
        flex: 1 1;
        position: relative;
        height: calc(100% - 40px);
    }
    .bar-chart-widget-body .graph-container .graph-tool-tip{
        padding: 6px 8px;
        border-radius: 2px;
        background-color: rgba(255, 255, 255, 0.8);
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);
    }
    .bar-chart-widget-body .graph-container .graph-tool-tip p{
        margin: 0px;
        font-size: 12px;
        white-space: nowrap;
        display: flex;
        align-items: center;
        color: rgb(104, 104, 104);
    }
    .bar-chart-widget-body .graph-container .graph-tool-tip .date-time-p{
        margin-bottom: 5px;
        display: flex;
        justify-content: center;
    }
    .bar-chart-widget-body .graph-container .graph-tool-tip .value-p{
        display: flex;
        justify-content: space-between;
    }
    .bar-chart-widget-body .graph-container .graph-tool-tip .icon-span{
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        margin-right: 6px;
    }
    .bar-chart-widget-body .graph-container .graph-tool-tip .id-span{
        margin-right: 20px;
    }
    .bar-chart-widget-body .graph-container .x-axis{
        position: absolute;
        bottom: 5px;
        display: flex;
        justify-content: space-between;
    }
    .bar-chart-widget-body .graph-container .x-axis .horizontal-line{
        position: absolute;
        top: 2px;
        left: -1px;
        right: 5px;
        border-bottom: 2px solid rgb(122, 122, 122);
    }
    .bar-chart-widget-body .graph-container .x-axis div{
        margin: 0px;
        font-size: 12px;
    }
    .bar-chart-widget-body .graph-container .x-axis div p{
        margin: 0px;
        width: 100%;
        text-align: center;
        color: rgb(63, 63, 63);
        font-size: 10px;
    }
    .bar-chart-widget-body .graph-container .loading-container{
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: -10px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: white;
    }
    .bar-chart-widget-body .graph-container .loading-container div{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 5%;
    }
    .bar-chart-widget-body .graph-container .loading-container .loading-icon{
        margin-top: 40%;
        width: 20px;
        height: 20px;
        border: 2px solid rgba(155, 30, 30, 0.952);
        border-top: 1px solid transparent;
        border-radius: 50%;
        animation: bar-chart-widget-body-graph-container-loading-container-loading-icon-rotate 01s linear infinite;
    }
    @keyframes bar-chart-widget-body-graph-container-loading-container-loading-icon-rotate {
        0%{
            transform: rotate(0deg);
        }
        100%{
            transform: rotate(360deg);
        }
    }
    .bar-chart-widget-body .graph-container .loading-container div p{
        margin-top: 10px;
        font-size: 13px;
        color: rgb(80, 80, 80);
    }
}
@media screen and (max-width:949px){
    .bar-chart-widget-container{
        position: relative;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        box-sizing: border-box;
    }
    .bar-chart-widget-header{
        width: 100%;
        padding: 16px 20px;
        padding-bottom: 0px;
        box-sizing: border-box;
    }
    
    .bar-chart-widget-header .details-header{
        display: flex;
        justify-content: space-between;
    }
    .bar-chart-widget-header .details-header p{
        margin: 0px;
    }
    .bar-chart-widget-header .details-header .control-buttons-container{
        display: flex;
        align-items: center;
    }
    .bar-chart-widget-header .details-header .export-button,
    .bar-chart-widget-header .details-header .maximize-button,
    .bar-chart-widget-header .details-header .minimize-button{
        position: relative;
        margin: 0px;
        border: none;
        background-color: transparent;
        cursor: pointer;
    }
    .bar-chart-widget-header .details-header .export-button img{
        height: 17px;
    }
    .bar-chart-widget-header .details-header .maximize-button img{
        height: 25px;
    }
    .bar-chart-widget-header .details-header .minimize-button img{
        height: 18px;
    }
    .bar-chart-widget-header .details-header .export-button .export-selections-container{
        position: absolute;
        z-index: 2;
        right: 8px;
        padding: 0px;
        border-radius: 2px;
        background-color: white;
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
    }
    .bar-chart-widget-header .details-header .export-button .export-selections-container button{
        width: 100%;
        text-align: left;
        padding: 5px 12px;
        display: block;
        white-space: nowrap;
        border: none;
        cursor: pointer;
        background-color: transparent;
    }
    .bar-chart-widget-header .details-header .export-button .export-selections-container button:hover{
        background-color: lightgray;
    }
    .bar-chart-widget-container .time-window-selector-container{
        position: relative;
    }
    .bar-chart-widget-container .show-time-window-selector-button{
        position: relative;
        padding: 0px;
        padding-top: 8px;
        padding-bottom: 4px;
        display: flex;
        align-items: center;
        cursor: pointer;
        border: none;
        color: rgb(136, 136, 136);
        background-color: transparent;
    }
    .bar-chart-widget-container .show-time-window-selector-button img{
        height: 16px;
        margin-right: 6px;
    }
    .bar-chart-widget-body{
        width: 100%;
        flex-grow: 1;
        padding: 10px 20px;
        display: flex;
        flex-direction: column;
        box-sizing: border-box;
    }
    .bar-chart-widget-body .legends-container .legend-container{
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .bar-chart-widget-body .legends-container .legend-container .key-container{
        display: flex;
        align-items: center;
    }
    .bar-chart-widget-body .legends-container .legend-container p{
        margin: 0px;
        margin-right: 4px;
        font-size: 13px;
        color: rgb(58, 58, 58);
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .bar-chart-widget-body .legends-container .legend-container .value-container p{
        font-weight: 500;
    }
    .bar-chart-widget-body .graph-container{
        flex: 1 1;
        position: relative;
        height: calc(100% - 40px);
    }
    .bar-chart-widget-body .graph-container .graph-tool-tip{
        padding: 6px 8px;
        border-radius: 2px;
        background-color: rgba(255, 255, 255, 0.8);
        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);
    }
    .bar-chart-widget-body .graph-container .graph-tool-tip p{
        margin: 0px;
        font-size: 12px;
        white-space: nowrap;
        display: flex;
        align-items: center;
        color: rgb(104, 104, 104);
    }
    .bar-chart-widget-body .graph-container .graph-tool-tip .date-time-p{
        margin-bottom: 5px;
        display: flex;
        justify-content: center;
    }
    .bar-chart-widget-body .graph-container .graph-tool-tip .value-p{
        display: flex;
        justify-content: space-between;
    }
    .bar-chart-widget-body .graph-container .graph-tool-tip .icon-span{
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        margin-right: 6px;
    }
    .bar-chart-widget-body .graph-container .graph-tool-tip .id-span{
        margin-right: 20px;
    }
    .bar-chart-widget-body .graph-container .x-axis{
        position: absolute;
        bottom: 7px;
        width: calc(100% - 46px);
        display: flex;
        justify-content: space-between;
    }
    .bar-chart-widget-body .graph-container .x-axis .horizontal-line{
        position: absolute;
        top: 2px;
        left: -1px;
        right: 5px;
        border-bottom: 2px solid rgb(122, 122, 122);
    }
    .bar-chart-widget-body .graph-container .x-axis div{
        margin: 0px;
        font-size: 12px;
    }
    .bar-chart-widget-body .graph-container .x-axis div p{
        margin: 0px;
        width: 100%;
        text-align: center;
        color: rgb(63, 63, 63);
        font-size: 10px;
    }
    .bar-chart-widget-body .graph-container .loading-container{
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: -10px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: white;
    }
    .bar-chart-widget-body .graph-container .loading-container div{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 5%;
    }
    .bar-chart-widget-body .graph-container .loading-container .loading-icon{
        margin-top: 40%;
        width: 20px;
        height: 20px;
        border: 2px solid rgba(155, 30, 30, 0.952);
        border-top: 1px solid transparent;
        border-radius: 50%;
        animation: bar-chart-widget-body-graph-container-loading-container-loading-icon-rotate 01s linear infinite;
    }
    @keyframes bar-chart-widget-body-graph-container-loading-container-loading-icon-rotate {
        0%{
            transform: rotate(0deg);
        }
        100%{
            transform: rotate(360deg);
        }
    }
    .bar-chart-widget-body .graph-container .loading-container div p{
        margin-top: 10px;
        font-size: 13px;
        color: rgb(80, 80, 80);
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/Widgets/Charts/BarChartWidget.css"],"names":[],"mappings":"AAAA;IACI;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,2BAA2B;QAC3B,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,8BAA8B;IAClC;IACA;QACI,WAAW;IACf;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;;;QAGI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,6BAA6B;QAC7B,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,UAAU;QACV,YAAY;QACZ,kBAAkB;QAClB,uBAAuB;QACvB,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,iBAAiB;QACjB,cAAc;QACd,mBAAmB;QACnB,YAAY;QACZ,eAAe;QACf,6BAA6B;IACjC;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,YAAY;QACZ,gBAAgB;QAChB,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,eAAe;QACf,YAAY;QACZ,yBAAyB;QACzB,6BAA6B;IACjC;IACA;QACI,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,sBAAsB;IAC1B;IACA;QACI,eAAe;QACf,gBAAgB;IACpB;IACA;QACI,UAAU;IACd;IACA;QACI,kBAAkB;QAClB,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;IAClC;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,iBAAiB;QACjB,eAAe;QACf,sBAAsB;QACtB,4DAA4D;IAChE;IACA;QACI,gBAAgB;IACpB;IACA;QACI,SAAO;QACP,kBAAkB;QAClB,yBAAyB;IAC7B;IACA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,0CAA0C;QAC1C,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,eAAe;QACf,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,yBAAyB;IAC7B;IACA;QACI,kBAAkB;QAClB,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,aAAa;QACb,8BAA8B;IAClC;IACA;QACI,qBAAqB;QACrB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,aAAa;QACb,8BAA8B;IAClC;IACA;QACI,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,UAAU;QACV,2CAA2C;IAC/C;IACA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,WAAW;QACX,WAAW;QACX,kBAAkB;QAClB,sBAAsB;QACtB,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,MAAM;QACN,SAAS;QACT,OAAO;QACP,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,gBAAgB;IACpB;IACA;QACI,eAAe;QACf,WAAW;QACX,YAAY;QACZ,0CAA0C;QAC1C,iCAAiC;QACjC,kBAAkB;QAClB,0GAA0G;IAC9G;IACA;QACI;YACI,uBAAuB;QAC3B;QACA;YACI,yBAAyB;QAC7B;IACJ;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,sBAAsB;IAC1B;AACJ;AACA;IACI;QACI,kBAAkB;QAClB,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,2BAA2B;QAC3B,mBAAmB;QACnB,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,mBAAmB;QACnB,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,8BAA8B;IAClC;IACA;QACI,WAAW;IACf;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;;;QAGI,kBAAkB;QAClB,WAAW;QACX,YAAY;QACZ,6BAA6B;QAC7B,eAAe;IACnB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,YAAY;IAChB;IACA;QACI,kBAAkB;QAClB,UAAU;QACV,UAAU;QACV,YAAY;QACZ,kBAAkB;QAClB,uBAAuB;QACvB,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,gBAAgB;QAChB,iBAAiB;QACjB,cAAc;QACd,mBAAmB;QACnB,YAAY;QACZ,eAAe;QACf,6BAA6B;IACjC;IACA;QACI,2BAA2B;IAC/B;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,YAAY;QACZ,gBAAgB;QAChB,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,eAAe;QACf,YAAY;QACZ,yBAAyB;QACzB,6BAA6B;IACjC;IACA;QACI,YAAY;QACZ,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,aAAa;QACb,sBAAsB;QACtB,sBAAsB;IAC1B;IACA;QACI,aAAa;QACb,mBAAmB;QACnB,8BAA8B;IAClC;IACA;QACI,aAAa;QACb,mBAAmB;IACvB;IACA;QACI,WAAW;QACX,iBAAiB;QACjB,eAAe;QACf,sBAAsB;QACtB,4DAA4D;IAChE;IACA;QACI,gBAAgB;IACpB;IACA;QACI,SAAO;QACP,kBAAkB;QAClB,yBAAyB;IAC7B;IACA;QACI,gBAAgB;QAChB,kBAAkB;QAClB,0CAA0C;QAC1C,0CAA0C;IAC9C;IACA;QACI,WAAW;QACX,eAAe;QACf,mBAAmB;QACnB,aAAa;QACb,mBAAmB;QACnB,yBAAyB;IAC7B;IACA;QACI,kBAAkB;QAClB,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,aAAa;QACb,8BAA8B;IAClC;IACA;QACI,qBAAqB;QACrB,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,wBAAwB;QACxB,aAAa;QACb,8BAA8B;IAClC;IACA;QACI,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,UAAU;QACV,2CAA2C;IAC/C;IACA;QACI,WAAW;QACX,eAAe;IACnB;IACA;QACI,WAAW;QACX,WAAW;QACX,kBAAkB;QAClB,sBAAsB;QACtB,eAAe;IACnB;IACA;QACI,kBAAkB;QAClB,MAAM;QACN,SAAS;QACT,OAAO;QACP,YAAY;QACZ,aAAa;QACb,uBAAuB;QACvB,mBAAmB;QACnB,uBAAuB;IAC3B;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,mBAAmB;QACnB,gBAAgB;IACpB;IACA;QACI,eAAe;QACf,WAAW;QACX,YAAY;QACZ,0CAA0C;QAC1C,iCAAiC;QACjC,kBAAkB;QAClB,0GAA0G;IAC9G;IACA;QACI;YACI,uBAAuB;QAC3B;QACA;YACI,yBAAyB;QAC7B;IACJ;IACA;QACI,gBAAgB;QAChB,eAAe;QACf,sBAAsB;IAC1B;AACJ","sourcesContent":["@media screen and (min-width:950px){\r\n    .bar-chart-widget-container{\r\n        position: relative;\r\n        height: 100%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: flex-start;\r\n        align-items: center;\r\n        box-sizing: border-box;\r\n    }\r\n    .bar-chart-widget-header{\r\n        width: 100%;\r\n        padding: 16px 20px;\r\n        padding-bottom: 0px;\r\n        box-sizing: border-box;\r\n    }\r\n    .bar-chart-widget-header .details-header{\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n    .bar-chart-widget-header .details-header p{\r\n        margin: 0px;\r\n    }\r\n    .bar-chart-widget-header .details-header .control-buttons-container{\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n    .bar-chart-widget-header .details-header .export-button,\r\n    .bar-chart-widget-header .details-header .maximize-button,\r\n    .bar-chart-widget-header .details-header .minimize-button{\r\n        position: relative;\r\n        margin: 0px;\r\n        border: none;\r\n        background-color: transparent;\r\n        cursor: pointer;\r\n    }\r\n    .bar-chart-widget-header .details-header .export-button img{\r\n        height: 17px;\r\n    }\r\n    .bar-chart-widget-header .details-header .maximize-button img{\r\n        height: 25px;\r\n    }\r\n    .bar-chart-widget-header .details-header .minimize-button img{\r\n        height: 18px;\r\n    }\r\n    .bar-chart-widget-header .details-header .export-button .export-selections-container{\r\n        position: absolute;\r\n        z-index: 2;\r\n        right: 8px;\r\n        padding: 0px;\r\n        border-radius: 2px;\r\n        background-color: white;\r\n        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);\r\n    }\r\n    .bar-chart-widget-header .details-header .export-button .export-selections-container button{\r\n        width: 100%;\r\n        text-align: left;\r\n        padding: 5px 12px;\r\n        display: block;\r\n        white-space: nowrap;\r\n        border: none;\r\n        cursor: pointer;\r\n        background-color: transparent;\r\n    }\r\n    .bar-chart-widget-header .details-header .export-button .export-selections-container button:hover{\r\n        background-color: lightgray;\r\n    }\r\n    .bar-chart-widget-container .time-window-selector-container{\r\n        position: relative;\r\n    }\r\n    .bar-chart-widget-container .show-time-window-selector-button{\r\n        position: relative;\r\n        padding: 0px;\r\n        padding-top: 8px;\r\n        padding-bottom: 4px;\r\n        display: flex;\r\n        align-items: center;\r\n        cursor: pointer;\r\n        border: none;\r\n        color: rgb(136, 136, 136);\r\n        background-color: transparent;\r\n    }\r\n    .bar-chart-widget-container .show-time-window-selector-button img{\r\n        height: 16px;\r\n        margin-right: 6px;\r\n    }\r\n    .bar-chart-widget-body{\r\n        width: 100%;\r\n        flex-grow: 1;\r\n        padding: 10px 20px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        box-sizing: border-box;\r\n    }\r\n    .bar-chart-widget-body .legends-container{\r\n        max-height: 15%;\r\n        overflow-y: auto;\r\n    }\r\n    .bar-chart-widget-body .legends-container::-webkit-scrollbar{\r\n        width: 5px;\r\n    }\r\n    .bar-chart-widget-body .legends-container::-webkit-scrollbar-thumb{\r\n        border-radius: 2px;\r\n        background-color: gray;\r\n    }\r\n    .bar-chart-widget-body .legends-container .legend-container{\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n    }\r\n    .bar-chart-widget-body .legends-container .legend-container .key-container{\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n    .bar-chart-widget-body .legends-container .legend-container p{\r\n        margin: 0px;\r\n        margin-right: 4px;\r\n        font-size: 13px;\r\n        color: rgb(58, 58, 58);\r\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    }\r\n    .bar-chart-widget-body .legends-container .legend-container .value-container p{\r\n        font-weight: 500;\r\n    }\r\n    .bar-chart-widget-body .graph-container{\r\n        flex: 1;\r\n        position: relative;\r\n        height: calc(100% - 40px);\r\n    }\r\n    .bar-chart-widget-body .graph-container .graph-tool-tip{\r\n        padding: 6px 8px;\r\n        border-radius: 2px;\r\n        background-color: rgba(255, 255, 255, 0.8);\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);\r\n    }\r\n    .bar-chart-widget-body .graph-container .graph-tool-tip p{\r\n        margin: 0px;\r\n        font-size: 12px;\r\n        white-space: nowrap;\r\n        display: flex;\r\n        align-items: center;\r\n        color: rgb(104, 104, 104);\r\n    }\r\n    .bar-chart-widget-body .graph-container .graph-tool-tip .date-time-p{\r\n        margin-bottom: 5px;\r\n        display: flex;\r\n        justify-content: center;\r\n    }\r\n    .bar-chart-widget-body .graph-container .graph-tool-tip .value-p{\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n    .bar-chart-widget-body .graph-container .graph-tool-tip .icon-span{\r\n        display: inline-block;\r\n        width: 10px;\r\n        height: 10px;\r\n        border-radius: 50%;\r\n        margin-right: 6px;\r\n    }\r\n    .bar-chart-widget-body .graph-container .graph-tool-tip .id-span{\r\n        margin-right: 20px;\r\n    }\r\n    .bar-chart-widget-body .graph-container .x-axis{\r\n        position: absolute;\r\n        bottom: 5px;\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n    .bar-chart-widget-body .graph-container .x-axis .horizontal-line{\r\n        position: absolute;\r\n        top: 2px;\r\n        left: -1px;\r\n        right: 5px;\r\n        border-bottom: 2px solid rgb(122, 122, 122);\r\n    }\r\n    .bar-chart-widget-body .graph-container .x-axis div{\r\n        margin: 0px;\r\n        font-size: 12px;\r\n    }\r\n    .bar-chart-widget-body .graph-container .x-axis div p{\r\n        margin: 0px;\r\n        width: 100%;\r\n        text-align: center;\r\n        color: rgb(63, 63, 63);\r\n        font-size: 10px;\r\n    }\r\n    .bar-chart-widget-body .graph-container .loading-container{\r\n        position: absolute;\r\n        top: 0;\r\n        bottom: 0;\r\n        left: 0;\r\n        right: -10px;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        background-color: white;\r\n    }\r\n    .bar-chart-widget-body .graph-container .loading-container div{\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n        margin-right: 5%;\r\n    }\r\n    .bar-chart-widget-body .graph-container .loading-container .loading-icon{\r\n        margin-top: 40%;\r\n        width: 20px;\r\n        height: 20px;\r\n        border: 2px solid rgba(155, 30, 30, 0.952);\r\n        border-top: 1px solid transparent;\r\n        border-radius: 50%;\r\n        animation: bar-chart-widget-body-graph-container-loading-container-loading-icon-rotate 01s linear infinite;\r\n    }\r\n    @keyframes bar-chart-widget-body-graph-container-loading-container-loading-icon-rotate {\r\n        0%{\r\n            transform: rotate(0deg);\r\n        }\r\n        100%{\r\n            transform: rotate(360deg);\r\n        }\r\n    }\r\n    .bar-chart-widget-body .graph-container .loading-container div p{\r\n        margin-top: 10px;\r\n        font-size: 13px;\r\n        color: rgb(80, 80, 80);\r\n    }\r\n}\r\n@media screen and (max-width:949px){\r\n    .bar-chart-widget-container{\r\n        position: relative;\r\n        height: 100%;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: flex-start;\r\n        align-items: center;\r\n        box-sizing: border-box;\r\n    }\r\n    .bar-chart-widget-header{\r\n        width: 100%;\r\n        padding: 16px 20px;\r\n        padding-bottom: 0px;\r\n        box-sizing: border-box;\r\n    }\r\n    \r\n    .bar-chart-widget-header .details-header{\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n    .bar-chart-widget-header .details-header p{\r\n        margin: 0px;\r\n    }\r\n    .bar-chart-widget-header .details-header .control-buttons-container{\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n    .bar-chart-widget-header .details-header .export-button,\r\n    .bar-chart-widget-header .details-header .maximize-button,\r\n    .bar-chart-widget-header .details-header .minimize-button{\r\n        position: relative;\r\n        margin: 0px;\r\n        border: none;\r\n        background-color: transparent;\r\n        cursor: pointer;\r\n    }\r\n    .bar-chart-widget-header .details-header .export-button img{\r\n        height: 17px;\r\n    }\r\n    .bar-chart-widget-header .details-header .maximize-button img{\r\n        height: 25px;\r\n    }\r\n    .bar-chart-widget-header .details-header .minimize-button img{\r\n        height: 18px;\r\n    }\r\n    .bar-chart-widget-header .details-header .export-button .export-selections-container{\r\n        position: absolute;\r\n        z-index: 2;\r\n        right: 8px;\r\n        padding: 0px;\r\n        border-radius: 2px;\r\n        background-color: white;\r\n        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);\r\n    }\r\n    .bar-chart-widget-header .details-header .export-button .export-selections-container button{\r\n        width: 100%;\r\n        text-align: left;\r\n        padding: 5px 12px;\r\n        display: block;\r\n        white-space: nowrap;\r\n        border: none;\r\n        cursor: pointer;\r\n        background-color: transparent;\r\n    }\r\n    .bar-chart-widget-header .details-header .export-button .export-selections-container button:hover{\r\n        background-color: lightgray;\r\n    }\r\n    .bar-chart-widget-container .time-window-selector-container{\r\n        position: relative;\r\n    }\r\n    .bar-chart-widget-container .show-time-window-selector-button{\r\n        position: relative;\r\n        padding: 0px;\r\n        padding-top: 8px;\r\n        padding-bottom: 4px;\r\n        display: flex;\r\n        align-items: center;\r\n        cursor: pointer;\r\n        border: none;\r\n        color: rgb(136, 136, 136);\r\n        background-color: transparent;\r\n    }\r\n    .bar-chart-widget-container .show-time-window-selector-button img{\r\n        height: 16px;\r\n        margin-right: 6px;\r\n    }\r\n    .bar-chart-widget-body{\r\n        width: 100%;\r\n        flex-grow: 1;\r\n        padding: 10px 20px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        box-sizing: border-box;\r\n    }\r\n    .bar-chart-widget-body .legends-container .legend-container{\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: space-between;\r\n    }\r\n    .bar-chart-widget-body .legends-container .legend-container .key-container{\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n    .bar-chart-widget-body .legends-container .legend-container p{\r\n        margin: 0px;\r\n        margin-right: 4px;\r\n        font-size: 13px;\r\n        color: rgb(58, 58, 58);\r\n        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    }\r\n    .bar-chart-widget-body .legends-container .legend-container .value-container p{\r\n        font-weight: 500;\r\n    }\r\n    .bar-chart-widget-body .graph-container{\r\n        flex: 1;\r\n        position: relative;\r\n        height: calc(100% - 40px);\r\n    }\r\n    .bar-chart-widget-body .graph-container .graph-tool-tip{\r\n        padding: 6px 8px;\r\n        border-radius: 2px;\r\n        background-color: rgba(255, 255, 255, 0.8);\r\n        box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.2);\r\n    }\r\n    .bar-chart-widget-body .graph-container .graph-tool-tip p{\r\n        margin: 0px;\r\n        font-size: 12px;\r\n        white-space: nowrap;\r\n        display: flex;\r\n        align-items: center;\r\n        color: rgb(104, 104, 104);\r\n    }\r\n    .bar-chart-widget-body .graph-container .graph-tool-tip .date-time-p{\r\n        margin-bottom: 5px;\r\n        display: flex;\r\n        justify-content: center;\r\n    }\r\n    .bar-chart-widget-body .graph-container .graph-tool-tip .value-p{\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n    .bar-chart-widget-body .graph-container .graph-tool-tip .icon-span{\r\n        display: inline-block;\r\n        width: 10px;\r\n        height: 10px;\r\n        border-radius: 50%;\r\n        margin-right: 6px;\r\n    }\r\n    .bar-chart-widget-body .graph-container .graph-tool-tip .id-span{\r\n        margin-right: 20px;\r\n    }\r\n    .bar-chart-widget-body .graph-container .x-axis{\r\n        position: absolute;\r\n        bottom: 7px;\r\n        width: calc(100% - 46px);\r\n        display: flex;\r\n        justify-content: space-between;\r\n    }\r\n    .bar-chart-widget-body .graph-container .x-axis .horizontal-line{\r\n        position: absolute;\r\n        top: 2px;\r\n        left: -1px;\r\n        right: 5px;\r\n        border-bottom: 2px solid rgb(122, 122, 122);\r\n    }\r\n    .bar-chart-widget-body .graph-container .x-axis div{\r\n        margin: 0px;\r\n        font-size: 12px;\r\n    }\r\n    .bar-chart-widget-body .graph-container .x-axis div p{\r\n        margin: 0px;\r\n        width: 100%;\r\n        text-align: center;\r\n        color: rgb(63, 63, 63);\r\n        font-size: 10px;\r\n    }\r\n    .bar-chart-widget-body .graph-container .loading-container{\r\n        position: absolute;\r\n        top: 0;\r\n        bottom: 0;\r\n        left: 0;\r\n        right: -10px;\r\n        display: flex;\r\n        justify-content: center;\r\n        align-items: center;\r\n        background-color: white;\r\n    }\r\n    .bar-chart-widget-body .graph-container .loading-container div{\r\n        display: flex;\r\n        flex-direction: column;\r\n        align-items: center;\r\n        margin-right: 5%;\r\n    }\r\n    .bar-chart-widget-body .graph-container .loading-container .loading-icon{\r\n        margin-top: 40%;\r\n        width: 20px;\r\n        height: 20px;\r\n        border: 2px solid rgba(155, 30, 30, 0.952);\r\n        border-top: 1px solid transparent;\r\n        border-radius: 50%;\r\n        animation: bar-chart-widget-body-graph-container-loading-container-loading-icon-rotate 01s linear infinite;\r\n    }\r\n    @keyframes bar-chart-widget-body-graph-container-loading-container-loading-icon-rotate {\r\n        0%{\r\n            transform: rotate(0deg);\r\n        }\r\n        100%{\r\n            transform: rotate(360deg);\r\n        }\r\n    }\r\n    .bar-chart-widget-body .graph-container .loading-container div p{\r\n        margin-top: 10px;\r\n        font-size: 13px;\r\n        color: rgb(80, 80, 80);\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
